import React from "react";
import styles from "../styles/campaignNotifications.module.scss";

const TABS = [
  { id: "all", label: "All users" },
  { id: "eligible", label: "Eligible" },
  { id: "sent", label: "Sent" },
];

export default function AudienceTabs({ audience, onChange }) {
  return (
    <div className={styles.tabs} role="tablist" aria-label="Campaign audience">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={audience === tab.id}
          className={`${styles.tab} ${audience === tab.id ? styles.tabActive : ""}`}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
